import React from 'react';
import { TagBlock } from './partials';
export var Tag = function Tag(_ref) {
  var small = _ref.small,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'accent1' : _ref$color,
    children = _ref.children,
    _onClick = _ref.onClick,
    _ref$withMargin = _ref.withMargin,
    withMargin = _ref$withMargin === void 0 ? false : _ref$withMargin;
  return React.createElement(TagBlock, {
    withMargin: Boolean(withMargin),
    small: Boolean(small),
    color: color,
    onClick: function onClick() {
      _onClick && _onClick();
    }
  }, children);
};